import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  color: #351778;
  padding: 0 30px;
  background: #ece7f0;
  h2,h3 {
    font-weight: bold;
  }

  display: grid;
  width: fit-content;
  grid-template-columns: 480px 1fr;
  grid-template-areas:
    "content video"
    "keypoints video";
  gap: 1em 2em;

  max-width: 1180px;
  margin: 0 auto;
  font-size: 1em;
  line-height: 1.3;

  h2 {
    font-size: 1.8em;
  }
  p, h2 {
    margin: 0;
  }

  .content {
    grid-area: content;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .keypoints {
    grid-area: keypoints;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .keypoint {
    display: flex;
    gap: 0.8em;

    svg {
        fill: #351778;
    }


    .keypoint--icon {
      display: flex;
      align-items: center;
      font-family: Nunito;
      font-size: 1.6em;
      margin-bottom: auto;

      img {
        width: 30px;
        height: 30px;
      }
    }

    .keypoint--content {
      display: flex;
      flex-direction: column;
      gap: 0.2em;
    }

    h3,p {
      margin: 0;
    }
  }

  .video {
    grid-area: video;
    width: fit-content;
    video {
     border-radius: 10px;
      max-width: 500px;
      width: 100%;
      overflow: hidden;
    }
  }


  @media screen and (max-width: 820px) {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 2em;
    padding-top: 60px;

    .content {
      order: 1;
      max-width: none;
    }

    .video {
      order: 2;
    }

    .keypoints {
      order: 3;
      align-items: center;
    }

    
    .keypoint {
      flex-direction: column;
      align-items: center;
    }
    
    .keypoint .keypoint--content {
      p {
        padding-left: 0;
      }
    }
    .keypoint .keypoint--title {
      justify-content: center;
    }
  }
`

export const ParentsV2_HowItWorks = (props: {
  title: string
  description: ReactElement | string | null
  keypoints: {
    title: string
    description: string
    iconUrl?: string
  }[]
  videoUrl: string
}) => {
  return <Wrapper>
    <div className='content'>
      <h2>{props.title}</h2>
      <p>{props.description}</p>
    </div>

    <div className='keypoints'>
      {props.keypoints.map(c => {
        return <div key={c.title} className='keypoint'>
          <div className='keypoint--icon' style={{ fontWeight: 'bolder' }}>{
            c.iconUrl ? <img src={c.iconUrl} /> : '✔'
          }</div>
          <div className='keypoint--content'>
            <h3>
              {c.title}
            </h3>
            <p>{c.description}</p>
          </div>
        </div>
      })}
    </div>

    <div className='video'>
      <video src={props.videoUrl} poster='/images/parents-v2/video-thumbnail.jpg' onClick={(e) => {
        const videoEl = e.target as HTMLVideoElement
        if (videoEl.paused) {
          videoEl.play()
        } else {
          videoEl.pause()
        }
      }} />
    </div>
  </Wrapper>
}
